import { Page } from '../../types'
import Source from '../../../components/Source'
import { APIs } from '../../../logic/scenarios/data'

const installCommand = (packageName: string, channel?: string) => `conda install ${channel && '-c ' + channel + ' '}${packageName}`

type InstallPackagesCondaProps = {
    framework: string
    isLocalLicense: boolean
}
const render = ({ framework, isLocalLicense }: InstallPackagesCondaProps) => {
    const isFramework = framework != ''
    const fw = framework ? APIs['python'].frameworks![framework].name : 'gurobipy'
    return <>
        <p>
            In your application, you will use {fw} for acccessing Gurobi functionality like defining and solving a model.
            You can install {fw} using <code>conda install</code>. 
            {isFramework && `To work with ${fw} you will also need to install gurobipy.`}
            The full command looks as follows:
        </p>
        <pre>{installCommand('gurobi', 'gurobi')} {isFramework && <><br/>{installCommand(framework, '')}</>}</pre>
        <h3>Notes</h3>
        <ul>            
            <li>Gurobi license tools (<code>grbgetkey, grbprobe, grb_ts</code>) are included when installing 
            Gurobi using <code>conda install</code></li>
            {isFramework && !isLocalLicense && <li>{fw} does not support customizing the Gurobi environment. 
            Therefore the only way to pass license details is by using a license file.</li>}
        </ul>
        <Source href="https://support.gurobi.com/hc/en-us/articles/360044290292-Installing-Gurobi-for-Python"/>
    </>
}

const InstallPackagesConda : Page<InstallPackagesCondaProps> = { title: 'Install packages using Conda', key: 'install-packages-conda', render }
export default InstallPackagesConda